import React, {useState} from 'react';
import {INSTALLATION_PAGES} from "../JobOrderInstallationPage";
import {toast} from "react-toastify";
import Card from "../../components/Card";
import CreateEditInstallation from "../../components/job/installation/CreateEditInstallation";

const JobOrderInstallationCreateEditPage = (props) => {
    const {
        jobId           = null,
        orderId         = null,
        installationId  = null,
        parentId        = "",
        onChangePage    = (INDEX, installation) => {}
    } = props;

    const handleClickBack = (event) => {
        event.preventDefault();
        onChangePage(INSTALLATION_PAGES.INDEX, null);
    }

    const handleCancel = () => {
        onChangePage(INSTALLATION_PAGES.INDEX, null);
    }

    const handleComplete = (installation) => {
        if (!!installationId) {
            toast.success(<div>{"Installation updated."}</div>);
        } else {
            toast.success(<div>{"Installation created."}</div>);
        }

        onChangePage(INSTALLATION_PAGES.INDEX, null);
    }

    const handleDelete = () => {
        toast.success(<div>{"Installation deleted."}</div>);

        onChangePage(INSTALLATION_PAGES.INDEX, null);
    }

    return (
        <React.Fragment>
            <Card
                title={!!installationId ? "Edit Installation" : "Create Installation"}
                classes={"mh-100 border-0"}
                controls={can('viewAny', 'installation') ? (
                    <button
                        onClick={(event) => handleClickBack(event)}
                        className={"btn font-weight-bold btn-outline-eh-off-black px-4 m-0"}
                    >
                        <i className={"fa fa-chevron-left mr-2"} />
                        <span>{"Back"}</span>
                    </button>
                ) : null}
            >
                <CreateEditInstallation
                    jobId={jobId}
                    orderId={orderId}
                    installationId={installationId}
                    onCancel={() => handleCancel()}
                    onComplete={(installation) => handleComplete(installation)}
                    onDelete={() => handleDelete()}
                    parentId={parentId}
                />
            </Card>
        </React.Fragment>
    );
}

export default JobOrderInstallationCreateEditPage;
